import CircularProgress from '@mui/material/CircularProgress';
import LottieDefault from 'react-lottie';
import React from 'react';
import branclubloading from '../../../assets/lottie/brandclub_logo_load.js';
import EllipsisBlueLoading from '../../../assets/lottie/ellipsis_darkblue.js';
import EllipsisLoading from '../../../assets/lottie/ellipsis.js';

var Lottie = LottieDefault;
var defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: branclubloading,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};
var ellipsisBlueOptions = {
    loop: true,
    autoplay: true,
    animationData: EllipsisBlueLoading,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};
var ellipsisOptions = {
    loop: true,
    autoplay: true,
    animationData: EllipsisLoading,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};
var Loading = function (_a) {
    var star = _a.star, ellipsisBlue = _a.ellipsisBlue, size = _a.size, ellipsis = _a.ellipsis;
    return (React.createElement("div", { style: {
            position: 'relative',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
        } }, ellipsisBlue ? (React.createElement(Lottie, { options: ellipsisBlueOptions, isClickToPauseDisabled: true, width: size !== null && size !== void 0 ? size : 30, height: size !== null && size !== void 0 ? size : 30 })) : ellipsis ? (React.createElement(Lottie, { options: ellipsisOptions, isClickToPauseDisabled: true, width: size !== null && size !== void 0 ? size : 30, height: size !== null && size !== void 0 ? size : 30 })) : star ? (React.createElement(Lottie, { options: defaultOptions, width: 200 })) : (React.createElement(CircularProgress, { size: 100 }))));
};
var ButtonLoadingEllipsis = function (_a) {
    var _b = _a.baseFontSize, baseFontSize = _b === void 0 ? 12 : _b, blue = _a.blue;
    var ellipsisContainerSize = baseFontSize * 1.4;
    var ellipsisSize = baseFontSize * 2.6;
    var yOffset = ellipsisSize / 10;
    return (React.createElement("div", { style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            width: ellipsisContainerSize,
            height: ellipsisContainerSize,
            minWidth: ellipsisContainerSize,
            minHeight: ellipsisContainerSize,
        } },
        React.createElement("div", { style: {
                position: 'absolute',
                width: ellipsisSize,
                height: ellipsisSize,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transform: "translateY(".concat(yOffset, "px)"),
            } },
            React.createElement(Loading, { ellipsis: !blue, ellipsisBlue: blue, size: ellipsisSize }))));
};

export { ButtonLoadingEllipsis, Loading };
//# sourceMappingURL=index.js.map
